export const ContactosActionTypes = {
    API_RESPONSE_SUCCESS: '@@contactos/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@contactos/API_RESPONSE_ERROR',

    GET_CONTACTO: '@@contactos/GET_CONTACTO',
    LIST_CONTACTOS: '@@contactos/LIST_CONTACTOS',
    UPDATE_CONTACTO: '@@contactos/UPDATE_CONTACTO',

    RESET: '@@contactos/RESET',
};
